import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CiSearch } from "react-icons/ci";

import { setStripePreference } from "../../store/slice/mappingSlice";

function MappingDropdown({ mappings, stripeFields, mappedItem, mappingsFor }) {
  const dispatch = useDispatch();
  const {
    selectPreferenceStripe,
    mappings: {
      mappings: { product: productMappings },
    },
  } = useSelector((state) => state.mapping);

  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState("");

  /**
   * This function is used to display the name inside the dropdown
   * @returns {String} dropdown text
   */
  const toggleDropdownText = () => {
    if (selectPreferenceStripe !== undefined) {
      return selectPreferenceStripe.HRF;
    } else if (!selectPreferenceStripe && !mappedItem.Stripe_FieldName_HRF) {
      return "select";
    } else {
      return mappedItem.Stripe_FieldName_HRF;
    }
  };

  /**
   * @description This function is responsible for searching the fields inside dropdown
   * @param {String} enteredInput input value used for searching
   */
  const onSearchFields = (searchValue) => {
    setSearchInput(searchValue);
    const searchArray = stripeFields.filter((fieldItem) => {
      return fieldItem.HRF.toLowerCase().includes(searchValue.toLowerCase());
    });
    setSearchResults(searchArray);
  };

  /**
   * @description This function is responsible for disabling the mapped fields inside the dropdown
   */
  const checkDisabledField = (fieldName) => {
    const isFound = (
      mappingsFor === "product" ? productMappings : mappings
    ).find((mappedItem) => {
      return mappedItem.Stripe_FieldName_CRF === fieldName;
    });

    if (isFound) {
      return mappedItem.Stripe_FieldName_CRF !== fieldName;
    }
    return isFound;
  };

  return (
    <Dropdown>
      <Dropdown.Toggle className="setup-fields-dropdown">
        {toggleDropdownText()}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="pt-0"
        renderOnMount={true}
        popperConfig={{ strategy: "fixed" }}
      >
        <div className="p-3">
          <div className="d-flex flex-row dropdown-search-box">
            <span className="my-auto">
              <CiSearch size={18} className="mx-2" />
            </span>
            <input
              type="search"
              placeholder="search.."
              className="w-100 dropdown-search"
              onChange={(e) => onSearchFields(e.target.value)}
            />
          </div>
        </div>
        <hr className="mt-0 px-3" style={{ border: "1px solid #E0E6EB" }} />

        <div className="setup-fields-dropdown-items-container">
          {searchInput.length > 0 && searchResults.length === 0 && (
            <div className="d-flex flex-row justify-content-center">
              <p className="rules-description">No results found</p>
            </div>
          )}
          {(searchInput.length > 0 ? searchResults : stripeFields).map(
            (fieldItem, index) => (
              <Dropdown.Item
                disabled={checkDisabledField(fieldItem.CRF)}
                key={index}
                className="px-3 dropdown-item"
                onClick={() => {
                  dispatch(
                    setStripePreference({
                      selectedOption: fieldItem,
                    })
                  );
                }}
              >
                {fieldItem.HRF}
              </Dropdown.Item>
            )
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default MappingDropdown;
